module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    staticClass: "address_settings",
    attrs: {
      "grid": true,
      "alignTop": true
    }
  }, [_c('FormInput', {
    attrs: {
      "placeholder": "Введите имя",
      "label": "Имя",
      "required": true,
      "v": _vm.$v.user.first_name,
      "error-text": _vm.firstNameErrorText || "Обязательное поле"
    },
    on: {
      "input": function($event) {
        return _vm.formatFio("user.first_name")
      }
    },
    model: {
      value: (_vm.user.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "first_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "user.first_name"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите фамилию",
      "label": "Фамилия",
      "required": true,
      "v": _vm.$v.user.last_name,
      "error-text": _vm.lastNameErrorText || "Обязательное поле"
    },
    on: {
      "input": function($event) {
        return _vm.formatFio("user.last_name")
      }
    },
    model: {
      value: (_vm.user.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "last_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "user.last_name"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите отчество",
      "label": "Отчество",
      "v": _vm.$v.user.patro_name,
      "error-text": _vm.fioErrorText
    },
    on: {
      "input": function($event) {
        return _vm.formatFio("user.patro_name")
      }
    },
    model: {
      value: (_vm.user.patro_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "patro_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "user.patro_name"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите СНИЛС",
      "label": "СНИЛС",
      "error": !!_vm.errors.snils,
      "error-text": _vm.errors.snils || _vm.snilsErrorText,
      "v": _vm.$v.user.snils,
      "mask": _vm.snilsMask
    },
    model: {
      value: (_vm.user.snils),
      callback: function($$v) {
        _vm.$set(_vm.user, "snils", $$v)
      },
      expression: "user.snils"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите номер телефона",
      "label": "Телефон",
      "error-text": "Пожалуйста, введите корректный номер телефона.",
      "required": true,
      "v": _vm.$v.user.phone,
      "mask": _vm.phoneMask
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  }), _c('div', {
    staticClass: "emailblock"
  }, [_c('FormInput', {
    attrs: {
      "placeholder": "Введите почту",
      "label": "Почта",
      "type": "email",
      "readonly": _vm.canChangeEmail,
      "error": _vm.validStateMachine(_vm.$v.user.email.$dirty, _vm.$v.user.email.$invalid),
      "error-text": (function () { return (typeof _vm.getMessage(_vm.$v.user.email) == "string" ? _vm.getMessage(_vm.$v.user.email) : _vm.getMessage(_vm.$v.user.email)(_vm.user.email)); })()
    },
    on: {
      "focus": function($event) {
        return _vm.$v.user.email.$reset()
      },
      "input": function($event) {
        return _vm.$v.user.email.$reset()
      },
      "blur": function($event) {
        return _vm.$v.user.email.$touch()
      }
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _c('Info', {
    staticClass: "mt-3",
    attrs: {
      "isConfirmed": _vm.canChangeEmail
    }
  }), (!_vm.$v.user.email.isUserFriendlyEmail && !_vm.canChangeEmail) ? _c('Message', {
    attrs: {
      "bottom": true,
      "color": true
    }
  }, [_vm._v("Уведомления не направляются на адреса с доменом " + _vm._s(_vm.getMessageByInsertedEmail(_vm.user.email)) + ". Укажите другой адрес.")]) : _vm._e(), (!_vm.$v.user.email.isUserFriendlyEmail && _vm.canChangeEmail) ? _c('Message', {
    attrs: {
      "bottom": true,
      "color": true
    }
  }, [_vm._v("Уведомления не направляются на адреса с доменом " + _vm._s(_vm.getMessageByInsertedEmail(_vm.user.email)) + ". Обратитесь в учреждение ДО для смены e-mail.")]) : _vm._e()], 1), _c('FormInput', {
    attrs: {
      "required": true,
      "placeholder": "Введите дату рождения",
      "label": "Дата рождения",
      "name": "birthday",
      "error-text": !_vm.user.birthday ? "Введите дату рождения" : "Не корректная дата",
      "v": _vm.$v.user.birthday,
      "mask": _vm.dateMask
    },
    model: {
      value: (_vm.user.birthday),
      callback: function($$v) {
        _vm.$set(_vm.user, "birthday", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "user.birthday"
    }
  }), _c('Select', {
    attrs: {
      "required": true,
      "label": "Пол",
      "name": "sex",
      "placeholder": "Выберите пол",
      "error-text": "Выберите пол",
      "v": _vm.$v.user.sex,
      "options": _vm.genderOptions
    },
    model: {
      value: (_vm.user.sex),
      callback: function($$v) {
        _vm.$set(_vm.user, "sex", $$v)
      },
      expression: "user.sex"
    }
  }), _c('Select', {
    attrs: {
      "required": true,
      "label": "Образование",
      "name": "edu_level_id",
      "placeholder": "Выберите уровень образования",
      "v": _vm.$v.user.edu_level_id,
      "error-text": "Выберите уровень образования",
      "options": _vm.levelOptions
    },
    model: {
      value: (_vm.user.edu_level_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "edu_level_id", $$v)
      },
      expression: "user.edu_level_id"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите новый пароль",
      "label": "Новый пароль",
      "type": "password",
      "autocomplete": "new-password",
      "error-text": "Не менее 6 символов",
      "required": true,
      "v": _vm.$v.passwords.newPassword
    },
    model: {
      value: (_vm.passwords.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "newPassword", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "passwords.newPassword"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите новый пароль еще раз",
      "label": "Повтор пароля",
      "type": "password",
      "autocomplete": "new-password",
      "error-text": "Пароли не совпадают",
      "required": true,
      "v": _vm.$v.passwords.comparePassword
    },
    model: {
      value: (_vm.passwords.comparePassword),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "comparePassword", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "passwords.comparePassword"
    }
  }), _c('div', {
    staticClass: "saveblock"
  }, [_c('div', {
    staticClass: "save"
  }, [_c('Message', {
    attrs: {
      "accent": _vm.correctUpdateProfile || _vm.correctUpdateEmail,
      "bottom": true,
      "color": _vm.isErrorColor
    }
  }, [_vm._v(_vm._s(_vm.infoText))]), _c('Button', {
    attrs: {
      "disabled": _vm.isDisabled,
      "isLoading": _vm.isLoading || _vm.isPassLoading
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Сохранить изменения")])], 1), _c('Button', {
    attrs: {
      "alignSelf": "end",
      "bordered": true
    },
    on: {
      "click": _vm.allReset
    }
  }, [_vm._v("Отменить изменения")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29545058","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/general/General.vue
// module id = 3c50cd8b06646231ca3e
// module chunks = 45